import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyState } from '../reducers';

export const getStoreManagementState = createSelector(
  getDragonflyState,
  (state) => state?.storeManagement,
);

export const getSideNavOpened = createSelector(
  getStoreManagementState,
  (state) => state?.sideNavOpened,
);

export const getPanelExpansion = createSelector(
  getStoreManagementState,
  (state) => state?.panelExpanded,
);

export const getStoreName = createSelector(getStoreManagementState, (state) => state?.storeName);

export const getStoreCode = createSelector(getStoreManagementState, (state) => state?.storeCode);

export const getShowInactiveStores = createSelector(
  getStoreManagementState,
  (state) => state?.showInactiveStores,
);

export const getTableCanUpdate = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('stores.update') ? true : false,
);

export const getCanCreateStore = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('stores.create') ? true : false,
);
